import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import SettelementTable from './SettelementTable';
import ButtonRefresh from 'components/base/ButtonRefresh';
import queryClient from 'service/queryClient';

export const suppliersBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'dt_kt',
    url: '/dtkt/provider'
  },
  {
    label: 'settlement_supplier',
    active: true
  }
];

const SettelementWithSuppliers = () => {
  const { t } = useTranslation();

  return (
    <div>
      <PageBreadcrumb items={suppliersBreadcrumbItems} />
      <div className="mb-5 d-flex gap-2 align-items-center">
        <h2>{t('settlement_supplier')}</h2>
        <ButtonRefresh
          onRefresh={() => {
            queryClient.refetchQueries('GET_PROVIDER');
          }}
        />
      </div>
      <SettelementTable />
    </div>
  );
};

export default SettelementWithSuppliers;
